import React from "react";
import { Truck } from "lucide-react";

export function BrandLogo({ size = "md", subtitle = "Operations Dashboard" }) {
  const dim = size === "lg" ? "w-14 h-14" : size === "sm" ? "w-9 h-9" : "w-11 h-11";
  const ic = size === "lg" ? 28 : size === "sm" ? 18 : 22;
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div className={`${dim} rounded-xl bg-primary text-primary-foreground flex items-center justify-center shadow-sm`}>
        <Truck size={ic} strokeWidth={2.4} />
      </div>
      <div className="leading-tight">
        <div className="font-display text-lg font-bold text-foreground">LedgerFlow</div>
        {subtitle ? <div className="text-xs text-muted-foreground">{subtitle}</div> : null}
      </div>
    </div>
  );
}
